import { E_GreenSocket_MessageTypes } from "./constants/GreenSocketConstants";

/**
 * @type {{
 *  destination: String,
 *  id: Number,
 *  type: String,
 *  data: *,
 * }}
 */
export const M_GreenSocketMessage = {
	type: E_GreenSocket_MessageTypes.MESSAGE,
	id: undefined,
	destination: undefined,
	data: null,
};

/**
 * @type {{
 *   refreshDelayCurve: {[key: number]: number},
 *   disconnectedRefreshTime: number,
 *   resubscribeAfterReconnect: boolean
 * }}
 */
export const M_GreenSocketOptions = {
	//Time (in ms) between reconnect attempts
	disconnectedRefreshTime: 5000,
	//Delay curve applied to the refresh time.
	// For more information @see RefresherV2
	refreshDelayCurve: {},
	//Whether to resubscribe to all currently subscribed topics after a connection is reestablished
	resubscribeAfterReconnect: true,
};
